// extracted by mini-css-extract-plugin
export default {"wrapper":"order-details-page_wrapper__4FGmH","container":"order-details-page_container__9OAYk"};